import { CreationWrapper } from "./CreationWrapper";

export const UpdateWrapper = CreationWrapper;